import * as Clipboard from "expo-clipboard"
import React from "react"
import { Toast } from "react-native-toast-notifications"

import { logger } from "@/base/logger"
import { useToasts } from "@/hooks/useToasts"
import i18n from "../translations/i18n"

/**
 * A hook that provides a function to copy a string to the clipboard.
 */
export function useClipboard() {
  const toast = useToasts()
  // TODO: use expo-clipboard
  const onCopy = React.useCallback(
    (copiedValue: string, options?: { successMessage?: string }) => {
      Clipboard.setStringAsync(copiedValue)
        .then(() =>
          toast.info(options?.successMessage ?? i18n.t("copiedToClipboard")),
        )
        .catch((error) => {
          toast.error(i18n.t("somethingWentWrong"))
          logger.error("Failed to copy to clipboard", error)
        })
    },
    [toast],
  )
  return onCopy
}

export function copyToClipboard(value: string) {
  Clipboard.setStringAsync(value)
    .then(() => {
      return Toast.show(i18n.t("copiedToClipboard"))
    })
    .catch((error) => {
      logger.error("Failed to copy to clipboard", error)
    })
}
